import styled from 'styled-components';

export const INSTRUCTION_HUB_DIALOG_WIDTH = 300;
const DIALOG_PADDING = 10;

const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  max-width: ${INSTRUCTION_HUB_DIALOG_WIDTH - DIALOG_PADDING * 2}px;
  padding: 6px 0;
`;

const MessageText = styled.p`
  margin: 0;
  color: white;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.4;
  text-align: center;
  white-space: normal;
`;

const OpenButtonWrapper = styled.div`
  margin-top: 12px;

  button {
    width: 100%;
  }
`;

export { MessageWrapper, MessageText, OpenButtonWrapper };



// WEBPACK FOOTER //
// ./components/instruction-hub-message/styled.js